import PropTypes from 'prop-types'
import { StyledTable } from 'components'
import { useRewardTableColumns } from 'domains/Reward/hooks'
import { useEffect, useState } from 'react'

const RewardTable = (props) => {
  const { dataSource } = props

  /* Getting table columns */
  const columns = useRewardTableColumns()

  /* Pagination params for table */
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showQuickJumper: true,
    showSizeChanger: true
  })

  /* Handle changes for table */
  const handleTableChange = (pagination) => setTableParams(pagination)

  /* Update total value for tableParams */
  useEffect(() => {
    dataSource?.length &&
      setTableParams((prev) => ({
        ...prev,
        total: dataSource?.length
      }))
  }, [dataSource])

  return (
    <StyledTable
      {...props}
      rowKey="_id"
      columns={columns}
      pagination={tableParams}
      onChange={handleTableChange}
    />
  )
}
RewardTable.propTypes = {
  dataSource: PropTypes.array
}

export default RewardTable
